<div>
  <div #selectComponent [id]="buttonId" class="account-sites-select" (click)="toggleDropdown()">
    <p data-test="filterSelectedSitesText">
      @if (selectedSites?.length) {
        {{ 'selected_sites' | ppTranslate }} ({{ selectedSites.length }})
      } @else {
        <span class="placeholder-text">
          {{ 'select_account_sites' | ppTranslate }}
        </span>
      }
    </p>

    <div class="select__caret">
      <div class="select__icon-container">
        <pp-icon
          [ppSVG]="
            dropdown.visible && dropdown.buttonId === buttonId
              ? iconMap[EIconPath.ICON_MISC_UP_ARROW_18]
              : iconMap[EIconPath.ICON_MISC_DOWN_ARROW_18]
          "
          aria-label="Select Caret Icon"
          ppColor="grey-400"
          ppClass="setSize18"
        />
      </div>
    </div>
  </div>
</div>
